import {
  isAndroid, isIOS, isMacOs, isWindows,
} from 'react-device-detect'

// Chrome puede tener el permiso de la página y aun así el sistema operativo bloquearlo sin avisar.
// Las notificaciones del navegador solo se ofrecen en computador (useBrowserNotifications).

export const notificationSettingsHint = () => {
  if (isMacOs) {
    return 'Si no te apareció ni sonó, abre Configuración del Sistema → Notificaciones → Google Chrome, activa "Permitir notificaciones" y "Reproducir sonido", y revisa que no tengas activado No molestar.'
  }
  if (isWindows) {
    return 'Si no te apareció ni sonó, abre Configuración → Sistema → Notificaciones, activa Google Chrome y revisa que no tengas activado No molestar.'
  }
  return 'Si no te apareció ni sonó, revisa que tu computador permita las notificaciones de tu navegador.'
}

const BROWSER_LOCATION_STEP = 'En el navegador, toca el ícono junto a la dirección de la página, entra a Permisos y permite Ubicación.'

export const locationSettingsHint = () => {
  if (isMacOs) {
    return `${BROWSER_LOCATION_STEP} En la Mac, abre Configuración del Sistema → Privacidad y seguridad → Localización y activa Google Chrome. Luego recarga la página.`
  }
  if (isWindows) {
    return `${BROWSER_LOCATION_STEP} En Windows, abre Configuración → Privacidad y seguridad → Ubicación y actívala. Luego recarga la página.`
  }
  if (isAndroid) {
    return `${BROWSER_LOCATION_STEP} Revisa también que la ubicación del celular esté encendida. Luego recarga la página.`
  }
  if (isIOS) {
    return `${BROWSER_LOCATION_STEP} En el iPhone, entra a Ajustes → Privacidad y seguridad → Localización y actívala para tu navegador. Luego recarga la página.`
  }
  return `${BROWSER_LOCATION_STEP} Luego recarga la página.`
}
